import CustomImage from '../../fragments/custom-image/CustomImage';
import Cta from '../../fragments/cta/Cta';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import ComponentHeading from '../../fragments/heading/ComponentHeading';

import { useRef, useEffect, useState } from 'react';
import { useDimensions } from '../../context/ThemeContextManagement';
import RichText from '../../fragments/rich-text/RichText';

export default function ContentMedia({ block, index }) {
  const dimensions = useDimensions();
  const textRef = useRef(null);
  const [lines, setlines] = useState(false);

  useEffect(() => {
    const el = textRef.current?.querySelector('span');
    if (!el) return;

    const lines = el.getClientRects().length - 1;
    setlines(lines < 1 ? 1 : lines);
  }, [dimensions.screenWidth]);

  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  return (
    <ComponentWrapper
      block={block}
      className={`ContentMedia image--${block.imageAlign}`}
    >
      {(block.largeHeading || block.smallHeading) && (
        <div className={'l-grid'}>
          <ComponentHeading
            heading={block.largeHeading}
            subheading={block.smallHeading}
            cta={block.cta}
          />
        </div>
      )}
      <div className={'l-grid'}>
        <div
          className={'l-grid__col l-grid__col--m-4-12 l-grid__col--m-push-1-12'}
        >
          {block.heading && (
            <HeadingTag
              className={`ContentMedia-headingMobile`}
              dangerouslySetInnerHTML={{ __html: block.heading }}
            />
          )}
          <div
            className="ContentMedia-media"
            style={{
              '--variable-space': `calc(var(--step-5) * 1.2 * ${lines}.33)`,
            }}
          >
            {block.image && (
              <CustomImage
                image={block.image}
                fill={true}
                parallax
                desktopWidth={33}
              />
            )}
          </div>
        </div>
        <div
          className={'l-grid__col l-grid__col--m-5-12 l-grid__col--m-push-1-12'}
        >
          <div className="ContentMedia-text">
            {block.heading && (
              <HeadingTag className={`ContentMedia-heading`} ref={textRef}>
                <span
                  // need to wrap in span so multi line check works
                  dangerouslySetInnerHTML={{ __html: block.heading }}
                />
              </HeadingTag>
            )}
            {block.content && (
              <div className="ContentMedia-content">
                <RichText html={block.content} />
              </div>
            )}
            {block.cta && (
              <div className="ContentMedia-cta">
                <Cta cta={block.cta} />
              </div>
            )}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
